import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivityData, SiteDiaryItem, SiteDiaryService} from '../../services/SiteDiary.service';

declare let laydate: any;


@Component({
  selector: 'SiteDiary-Details-addActivity',
  templateUrl: './SiteDiary-Details-addActivity.component.html',
  styleUrls: ['./SiteDiary-Details-addActivity.component.sass']
})
export class SiteDiaryDetailsAddActivityComponent implements OnInit {
  
  @Input() public summaryData: SiteDiaryItem
  @Input() public updataActivty:any
  @Input() public teamIndex:any
  @Input() public isEdit:any
  @Output() close = new EventEmitter();

  public sections = []
  public protions = []

  public displayPupop = false
  public pupopType:any
  public isShowProtionOther = false

  public activityData:ActivityData = {
    site_diary_id: 1,
    location: "",
    activity: "",
    period_start: "08:00",
    period_end: "18:00",
    section_id: null,
    protion_id: null,
    material: "",
    remark: "",
    labours: [],
    plant: [],
    labur_number:0,
    plant_number:0,
    plant_ldle:0,
    plant_working:0,
    qty:'',
    protion_others:''
  }

  constructor(
    public service: SiteDiaryService,
  ) { }

  // 格式化数字，保留一位小数
  formatNumber(value: number): string {
    return Number(value || 0).toFixed(1);
  }

  ngOnInit() {
    //console.log(this.updataActivty)
    if(this.updataActivty){
      // 确保数值类型字段被正确转换为数字
      this.activityData = {
        ...this.updataActivty,
        labur_number: Number(this.updataActivty.labur_number) || 0,
        plant_working: Number(this.updataActivty.plant_working) || 0,
        plant_ldle: Number(this.updataActivty.plant_ldle) || 0,
      };
    }
    this.service.getActivitiesSections({}).subscribe((res:any)=>{
      this.sections = res.sort( (pre:any,next:any) => {
       if( pre.name > next.name ) {
         return 1
       } else {
         return -1
       }
      })
    })
    this.service.getActivitiesProtions({}).subscribe((res:any)=>{
      this.protions =  res.sort( (pre:any,next:any) => {
        if( pre.name > next.name ) {
          return 1
        } else {
          return -1
        }
      })
      this.protionChange()
    })
  }

  ngAfterViewInit(){
    if(!this.isEdit) return
    jQuery('#addActivity')[0].childNodes.forEach((res:any)=>{
      if(res.className == 'summary-key-value' || res.className == 'summary-text-key-value'){
        res.children[1].disabled = true
      }
    })
  }

  protionChange(){
    const data:any = this.protions.find((res:any)=>res.id == this.activityData.protion_id)
    if(data.name.toLowerCase() == 'others'){
      this.isShowProtionOther = true
    }else{
      this.isShowProtionOther = false
      this.activityData.protion_others = ''
    }
  }

  //时间事件
  period_startChange() {
    if(this.summaryData.state != 'draft'&&this.summaryData.state != 'rejected') return
    laydate.render({
      elem: '#period_start'
      ,type: 'time'
      ,value:this.activityData.period_start
      ,format: 'HH:mm'
      ,lang: 'en',
      show:true
      ,done:(value:any)=>{
        //console.log(value)
        this.activityData.period_start = value
      }
    });
  }
  period_endChange() {
    if(this.summaryData.state != 'draft'&&this.summaryData.state != 'rejected') return
    laydate.render({
      elem: '#period_end'
      ,type: 'time'
      ,value:this.activityData.period_end
      ,format: 'HH:mm'
      ,lang: 'en',
      show:true
      ,done:(value:any)=>{
        //console.log(value)
        this.activityData.period_end = value
      }
    });
  }

  //添加列表弹窗
  toAddPlAndLab(value:any){
    this.pupopType = value
    this.displayPupop = true
  }

  pupopClose(data:any){
    this.displayPupop = !this.displayPupop
    // if(data){
    //   Object.assign(this.activityData, ...data)
    //   //console.log(this.activityData)
    // }
    
  }

  submitClick(){
    //console.log(this.activityData)
    this.activityData.site_diary_id = this.summaryData.id
    if(this.updataActivty){
      let data:any = this.activityData
      data['activity_id'] = this.updataActivty.id
      this.service.updataActivities(data).subscribe((res:any)=>{
        //console.log(res)
        this.close.emit()
        jQuery('#top-menu').css('z-index','22')

      })
    }else{
      this.service.addActivities(this.activityData, this.teamIndex).subscribe((res:any)=>{
        //console.log(res)
        this.close.emit()
        jQuery('#top-menu').css('z-index','22')
      })
    }
  }

  //关闭弹窗按钮
  closeClick(){
    this.close.emit()
    jQuery('#top-menu').css('z-index','22')
  }

}
